import { render } from "./List.vue?vue&type=template&id=e8434d10"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
script.render = render

export default script